import regex from './regex'

export default regex(/\d{1}/, 'At least 1 number')
